import React from "react";
import { useUserStore } from "@/src/store/useUserStore";
const UserMap: React.FC = () => {
  const { user } = useUserStore();

  return (
    <div className="overflow-hidden h-[144px] w-[144px] rounded-xl">
      {user ? (
        <img
          src={`https://api.neshan.org/v4/static?key=service.8571598ab7054e6cbde1bb6aafbd9a72&type=dreamy&zoom=12&width=144&height=144&center=${user.address.latitude},${user.address.longitude}&markerToken=151238.zM4AYekC`}
          alt=""
        />
      ) : null}
    </div>
  );
};

export default UserMap;
